import { cn } from "@repo/lib";
import { useAtom } from "jotai";
import { allocatedRoomBarIsOpenAtom } from "@/lib/atoms/allocated-room-bar";

interface FabProps {
  onClick: () => void;
  children: React.ReactNode;
  className?: string;
}

export const Fab = ({ onClick, children, className = "" }: FabProps): JSX.Element => {
  const [allocatedRoomBarIsOpen] = useAtom(allocatedRoomBarIsOpenAtom);

  return (
    <button
      onClick={onClick}
      type="button"
      id="livance-fab"
      className={cn(
        "rounded-3xl fixed w-[64px] h-[64px] bg-primary-400 active:bg-primary-500 text-white shadow-lg flex items-center justify-center z-40",
        { "allocated-room-bar-is-open": allocatedRoomBarIsOpen },
        className,
      )}
    >
      {children}
    </button>
  );
};
